import { periodFormat } from 'utils/common';
import { underlineToSpace } from 'utils/common';

export const createUnderlineToSpace = (arrFrom = [], arrTo) => {
  arrFrom.map(item => {
    if (item === 'paypal_express_checkout') {
      arrTo.push({
        value: item,
        label: 'PayPal'
      });
    } else if (item !== '-' && item !== 'NA') {
      arrTo.push({
        value: item,
        label: underlineToSpace(item)
      });
    } else {
      arrTo.unshift({
        value: item,
        label: item
      });
    }
    return '';
  });
};

export const AllTenantsReq = filter => {
  const REQ_BODY = {
    filters: {
      companyName: filter.companyName ? filter.companyName : '*',
      firstPaymentDate: periodFormat(filter.firstPaymentDate),
      nextBillingDate: periodFormat(filter.nextBillingDate),
      firstInvoiceAt: periodFormat(filter.firstInvoiceAt),
      tmUtilized: {
        from: filter.tmUtilized.from ? filter.tmUtilized.from : '*',
        to: filter.tmUtilized.to ? filter.tmUtilized.to : '*'
      },
      psUtilized: {
        from: filter.psUtilized.from ? filter.psUtilized.from : '*',
        to: filter.psUtilized.to ? filter.psUtilized.to : '*'
      },
      appsUtilized: {
        from: filter.appsUtilized.from ? filter.appsUtilized.from : '*',
        to: filter.appsUtilized.to ? filter.appsUtilized.to : '*'
      },
      plan: filter.plan[0] ? filter.plan : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      status: filter.status[0] ? filter.status : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      country: filter.country[0] ? filter.country : '*',
      industry: filter.industry[0] ? filter.industry : '*',
      partnerType: filter.partnerType[0] ? filter.partnerType : '*',
      poc: filter.poc[0] ? filter.poc : '*',
      region: filter.region[0] ? filter.region : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      'coupons.name': filter['coupons.name'][0] ? filter['coupons.name'] : '*',
      'coupons.type': filter['coupons.type'][0] ? filter['coupons.type'] : '*',
      'coupons.duration': filter['coupons.duration'][0]
        ? filter['coupons.duration']
        : '*',
      'qbr.occurredDate': periodFormat(filter['qbr.occurredDate']),
      'qbr.sentiment': filter['qbr.sentiment'][0]
        ? filter['qbr.sentiment']
        : '*',
      'qbr.isExist': filter['qbr.isExist']
        ? filter['qbr.isExist'] === 'True'
          ? true
          : false
        : '*',
      isTestTenant: filter.isTestTenant
        ? filter.isTestTenant === 'True'
          ? true
          : false
        : '*',
      arr: {
        from: filter.arr.from ? +filter.arr.from : '*',
        to: filter.arr.to ? +filter.arr.to : '*'
      },
      mau: {
        from: filter.mau.from ? +filter.mau.from : '*',
        to: filter.mau.to ? +filter.mau.to : '*'
      },
      npsScore: {
        from: filter.npsScore.from ? +filter.npsScore.from : '*',
        to: filter.npsScore.to ? +filter.npsScore.to : '*'
      },
      openTickets: {
        from: filter.openTickets.from ? +filter.openTickets.from : '*',
        to: filter.openTickets.to ? +filter.openTickets.to : '*'
      },
      csatChatScore: {
        from: filter.csatChatScore.from ? +filter.csatChatScore.from : '*',
        to: filter.csatChatScore.to ? +filter.csatChatScore.to : '*'
      },
      csatTicketScore: {
        from: filter.csatTicketScore.from ? +filter.csatTicketScore.from : '*',
        to: filter.csatTicketScore.to ? +filter.csatTicketScore.to : '*'
      },
      healthStatus: filter.healthStatus[0] ? filter.healthStatus : '*',
      healthPoint: {
        from: filter.healthPoint.from ? +filter.healthPoint.from : '*',
        to: filter.healthPoint.to ? +filter.healthPoint.to : '*'
      },
      paymentType: filter.paymentType[0] ? filter.paymentType : '*',
      terminationStatus: filter['terminationStatus'][0]
        ? filter['terminationStatus']
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };

  return REQ_BODY;
};
